import { ReactNode } from "react";

export function Kbd({ children }: { children: ReactNode }) {
  return (
    <kbd className="inline-flex items-center rounded-xs border border-paper-line-strong border-b-2 bg-paper-2 px-1.5 py-0.5 font-mono text-[10.5px] text-ink-2">
      {children}
    </kbd>
  );
}
